import type { ExcalidrawImperativeAPI } from "@excalidraw/excalidraw/types";

import { stashCopySeed } from "./copySeed";

import { getDiagramLink } from ".";

// Promote the current (local or existing) scene into a NEW server diagram in the
// active workspace: create the diagram, stash the scene keyed by its MUID, then
// navigate to it — the stash is applied on the room's first SCENE_INIT (see the
// Collab INIT handler). This is the one "save my drawing to my workspace" path,
// shared by the Save dialog card and the post-login resume.

// sessionStorage flag: set before redirecting an anonymous user to login so we
// can finish the save when they return authenticated. Survives the OAuth round
// trip (same tab, same origin); the local scene meanwhile persists in localStorage.
export const PENDING_WORKSPACE_SAVE = "pendingWorkspaceSave";

export const saveSceneToWorkspace = async (
  excalidrawAPI: ExcalidrawImperativeAPI,
  name: string,
): Promise<void> => {
  const res = await fetch("/api/diagrams", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ name }),
  });
  if (!res.ok) {
    throw new Error(`Could not create diagram (HTTP ${res.status})`);
  }
  const created = (await res.json()) as { muid: string };
  stashCopySeed(created.muid, {
    elements: excalidrawAPI.getSceneElements(),
    files: excalidrawAPI.getFiles(),
  });
  window.location.href = getDiagramLink(created.muid);
};

/** Stash the save intent and send the user to Google login; resumed on return. */
export const signInThenSaveToWorkspace = (): void => {
  try {
    sessionStorage.setItem(PENDING_WORKSPACE_SAVE, "1");
  } catch {
    // non-fatal — they'll just click Save again after signing in
  }
  window.location.href = "/api/auth/login";
};
